export const settings = {
	...window.vino,
};
